import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HotelCard = ({ hotel, onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleDateString('pt-BR');
  };

  const getStatusColor = (isActive) => {
    return isActive ? 'bg-success/10 text-success' : 'bg-warning/10 text-warning';
  };

  const getStatusText = (isActive) => {
    return isActive ? 'Ativo' : 'Inativo';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-200">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          {hotel.logo ? (
            // Exibir logo do hotel se disponível
            <div 
              className="rounded-lg flex items-center justify-center overflow-hidden bg-white border border-border"
              style={{
                width: `${hotel.logoSize || 64}px`,
                height: `${hotel.logoSize || 64}px`
              }}
            >
              <img 
                src={hotel.logo} 
                alt={`Logo ${hotel.name}`}
                className="w-full h-full object-contain"
                onError={(e) => {
                  // Fallback para ícone se a imagem falhar
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div 
                className="bg-primary/10 rounded-lg flex items-center justify-center hidden"
                style={{
                  width: `${hotel.logoSize || 64}px`,
                  height: `${hotel.logoSize || 64}px`
                }}
              >
                <Icon 
                  name="Building2" 
                  size={Math.floor((hotel.logoSize || 64) * 0.5)} 
                  className="text-primary" 
                />
              </div>
            </div>
          ) : (
            // Ícone padrão se não houver logo
            <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Building2" size={32} className="text-primary" />
            </div>
          )}
          <div>
            <h3 className="text-lg font-semibold text-foreground">{hotel.name}</h3>
            <p className="text-sm text-muted-foreground">Código: {hotel.code}</p>
          </div>
        </div>
        
        <div className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(hotel.isActive)}`}>
          {getStatusText(hotel.isActive)}
        </div>
      </div>

      {/* Description */}
      {hotel.description && (
        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
          {hotel.description}
        </p>
      )}

      {/* Location */}
      <div className="space-y-2 mb-4">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="MapPin" size={14} />
          <span>{hotel.address}</span>
        </div>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Globe" size={14} />
          <span>{hotel.city}, {hotel.state} - {hotel.country}</span>
        </div>
      </div>

      {/* Contact Info */}
      <div className="space-y-2 mb-4">
        {hotel.phone && (
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Phone" size={14} />
            <span>{hotel.phone}</span>
          </div>
        )}
        
        {hotel.email && (
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Mail" size={14} />
            <span className="truncate">{hotel.email}</span>
          </div>
        )}
        
        {hotel.website && (
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Globe" size={14} />
            <a 
              href={hotel.website} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:underline truncate"
            >
              {hotel.website.replace(/^https?:\/\//, '')}
            </a>
          </div>
        )}
      </div>

      {/* Metadata */}
      <div className="flex items-center justify-between text-xs text-muted-foreground mb-4">
        <span>Criado em: {formatDate(hotel.createdAt)}</span>
        <span>Atualizado: {formatDate(hotel.updatedAt)}</span>
      </div>

      {/* Actions */}
      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onEdit(hotel)}
          iconName="Edit"
          iconPosition="left"
          className="flex-1"
        >
          Editar
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onDelete(hotel)}
          iconName="Trash2"
          iconPosition="left"
          className="text-destructive border-destructive hover:bg-destructive hover:text-white"
        >
          Excluir
        </Button>
      </div>
    </div>
  );
};

export default HotelCard;
